export default __webpack_public_path__ + "static/media/rt.81f09e06.svg";